import BigNumber from "bignumber.js";

export class Config {
  pool: string;
  poolReservedRate: BigNumber;
  // quoteDecimal: number;
  initialMarginRiskRate: BigNumber;
  // liquidateRate: BigNumber;
  // clearRate: BigNumber;
  // liquidationReward: BigNumber;
  riskFreeRate: BigNumber;
  priceRatio: BigNumber;
  priceRatio2: BigNumber;
  priceRatioUtilization: BigNumber;
  spotFee: BigNumber;
  optionFee: BigNumber;
  minPremium: BigNumber;
  exerciseFeeRate: BigNumber;
  profitFeeRate: BigNumber;
  // Vault public vault;
  // address public quote;
  // address public feeAccount;
  // bool public initialized;
}
